module.exports = __webpack_public_path__ + "static/media/lod-m.3af7917d.svg";